import Tag from '../Tag';

/**
 * ConsentManager.Tag.ScriptTag
 *
 * @author Felix Kiesewetter <info@felixkiesewetter.de>
 * @lastModified 2024-12-19 Moved enable script tag from ConsentManager to here.
 * @package felixkiesewetter-js/consentmanager
 * @since 5.0.0
 */
class ScriptTag extends Tag
{

    /**
     * Opt-in script tag
     */
    public optIn() :Tag
    {
        const scriptTags :NodeList = document.querySelectorAll(`script[type="text/plain"][data-consent="${this.getName()}"]`);
        if (scriptTags.length) {
            scriptTags?.forEach((scriptTag :HTMLScriptElement) :void => {
                const newScriptTag :HTMLScriptTag = scriptTag.cloneNode(true);
                newScriptTag.setAttribute('type', 'text/javascript');
                if (newScriptTag.hasAttribute('data-src')) {
                    newScriptTag.setAttribute('src', newScriptTagnewScriptTag.getAttribute('data-src'));
                    scriptTag.removeAttribute('data-src');
                }
                scriptTag.replaceWith(newScriptTag);
                this.getConsentManager()
                    .getDebugger()
                    .log(`ConsentManager.#enableScriptTag(${this.getName()})`, `Enabled \<script\> with attribute data-consent="${this.getName()}"`);
            });
        }
        else {
            this.getConsentManager()
                .getDebugger()
                .warn(`ConsentManager.#enableScriptTag(${this.getName()})`, `There is no \<script\> with attribute data-consent="${this.getName()}"`);
        }
        return super.optIn();
    }

}

export default ScriptTag;
